//@flow
import React, { Component } from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import theme from './IntelliSortDatePicker.scss';
import { datePickerButtonFactory } from 'common/components/core/date_picker/DatePickerButton';
import TimeUtils from 'common/utils/TimeUtils';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import { Icon } from 'common/components/core/icon';

import intelliSortIds from 'common/tests/intellisort/intelliSortIds.json';

type Props = {
    selectedDate: Date,
    theme: Object,
    onDateChange: (date: Date) => void,
    className?: string | any
};
const ButtonPopoverComponent = ({ selectedDate, t }) => {
    return (
        <div className={theme.buttonPopover}>
            <div className={theme.date}>
                {t('selectedDate')}
                :&nbsp;
                {TimeUtils.format(selectedDate, 'Do MMM YYYY')}
            </div>
        </div>
    );
};

const ButtonComponent = ({ theme, selectedDate, isVisible, onClick, t }) => {
    const buttonPopoverContent = ButtonPopoverComponent({
        selectedDate,
        t
    });
    return (
        <ButtonWithPopover
            hidePopoverOnClick
            popOverClassName={classnames({
                [theme.hide]: isVisible
            })}
            triggerPopoverOn={PopoverTriggerEnum.Hover}
            popOverContent={buttonPopoverContent}
            theme={theme}
            className={theme.datePickerButton}
            buttonType={ButtonTypes.Solid}
            semibold
            ripple={false}
            onClick={onClick}
            testId={intelliSortIds.datePicker}
        >
            <div className={theme.labelWrap}>
                <span className={theme.left}>
                    <div className={theme.dateLabel}>Date</div>
                    <span className={classnames(theme.date)}>
                        {TimeUtils.format(selectedDate, 'Do MMM YYYY')}
                    </span>
                </span>
                <Icon
                    theme={theme}
                    className={theme.arrowIconWrap}
                    icon={isVisible ? 'caret_up' : 'caret_down'}
                />
            </div>
        </ButtonWithPopover>
    );
};

const IntelliSortDatePickerButton = datePickerButtonFactory({
    ButtonComponent
});

class IntelliSortDatePicker extends Component<Props, State> {
    state: State;
    constructor(props: Props) {
        super(props);
        this.state = {
            isVisible: false
        };
    }

    handleDateChange = (date: Date) => {
        const { onDateChange } = this.props;
        onDateChange(date);
    };

    render() {
        const { selectedDate, theme, onDateChange, t } = this.props;
        return (
            <IntelliSortDatePickerButton
                theme={theme}
                onDateChange={onDateChange}
                selectedDate={selectedDate}
                t={t}
            />
        );
    }
}

const ThemedIntelliSortDatePicker = compose(
    themr('LiveViewDatePicker', theme),
    translate('intelliSort')
)(IntelliSortDatePicker);
export default ThemedIntelliSortDatePicker;
export { ThemedIntelliSortDatePicker as IntelliSortDatePicker };
